// This file is designed to add extra functionalities to Plugin class

var PluginInfinityGettersMixin = {
  getContext: function () {
    return this.storage.getSession('context')
  },

  getSessionId: function () {
    return this.storage.getSession('session') || this.storage.getLocal('session')
  },

  getStoredData: function () {
    return this.storage.getSession('data') || this.storage.getLocal('data')
  },

  getDataTime: function () {
    return this.storage.getSession('dataTime') || this.storage.getLocal('dataTime')
  },

  getLastActive: function () {
    return this.storage.getSession('lastactive') || this.storage.getLocal('lastactive')
  },

  setStoredData: function (data) {
    this.storage.setLocal('data', data)
    this.storage.setSession('data', data)
  },

  setSessionId: function (session) {
    this.storage.setLocal('session', session)
    this.storage.setSession('session', session)
  },

  setDataTime: function (time) {
    this.storage.setLocal('dataTime', time)
    this.storage.setSession('dataTime', time)
  },

  setLastActive: function (last) {
    this.storage.setLocal('lastactive', last)
    this.storage.setSession('lastactive', last)
  },

  getPageName: function () {
    if (document && document.title) {
      return document.title
    }
  },

  getIsSessionExpired: function () {
    var now = new Date().getTime()
    return !this.getSessionId() || (this.infinity.getFirstActive() < now - this.sessionExpire)
  },

  getIsDataExpired: function () {
    var now = new Date().getTime()
    return !this.getStoredData() || (this.infinity.getFirstActive() < now - this.sessionExpire)
  }
}

module.exports = PluginInfinityGettersMixin
